export const UtilitesConstants = {
  CustomQuery: { NoData: 'No data found!' },
};



// WEBPACK FOOTER //
// ./src/pages/utilities/helper/constants.js